export default __webpack_public_path__ + "static/media/icn-acceleration.6de30130.svg";